module.exports = __webpack_public_path__ + "media/images/lb/618-48db00d100e9a7c69254cd8bea40c4ad.svg";